import { createClient } from '@supabase/supabase-js'
import { createLogger } from '../utils/logger'

const logger = createLogger('supabase')


// IMPORTANT: Replace with your actual Supabase URL and Anon Key
// You can find these in your Supabase project settings under "API"
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY
 
if (!supabaseUrl || !supabaseAnonKey) {
  logger.error('Supabase configuration missing', {
    action: 'init',
    has_url: Boolean(supabaseUrl),
    has_anon_key: Boolean(supabaseAnonKey),
  });
  // You might want to throw an error here in production to halt execution
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
})